import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class TicketApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/ticket' + path, queryMap);
  }

  postProblemTicket(
    problem_item_id: number,
    bus_seat_id: number,
    order_id: string,
    platform_id: number,
    description: string,
    screenshot_url: string,
  ) {
    const body = {
      problem_item_id,
      bus_seat_id,
      order_id,
      platform_id,
      description,
      screenshot_url,
    };
    const url = this.buildurl('');
    return this.http.post(url, body);
  }

  findProblemTickets(status: string) {
    const q = {
      status,
    };
    const url = this.http.buildurl('/tickets', q);
    return this.http.fget(url);
  }

  getProblemTicket(id: number) {
    const url = this.buildurl(`/${id}`);
    return this.http.fget(url);
  }

  confirmProblemTicket(id: number) {
    const url = this.buildurl(`/${id}/confirm`);
    return this.http.put(url, {});
  }

  reopenProblemTicket(id: number) {
    const url = this.buildurl(`/${id}/reopen`);
    return this.http.put(url, {});
  }

  findSeatTicket(keyword: string) {
    const q = {
      keyword,
    };
    const url = this.buildurl('/seats', q);
    return this.http.fget(url);
  }

  /**
   * 【已联调】查询当前用户是否已完成「获取支持」新手教程。
   * 后端约定：
   *   GET /ticket/tutorial/status
   *   成功返回: { status: 0, data: { completed: true } }   // completed=true 表示已完成，前端不再展示教程
   *   未完成:   { status: 0, data: { completed: false } }
   */
  getSupportGuideStatus() {
    const url = this.buildurl('/tutorial/status');
    return this.http.fget(url);
  }

  /**
   * 【已联调】标记当前用户已完成「获取支持」新手教程。
   * 教程最后一步点击「完成」时调用；调用成功后，下次进入页面 getSupportGuideStatus
   * 返回 completed=true，教程不再弹出。
   * 后端约定：
   *   POST /ticket/tutorial/complete   body: {}
   *   成功返回: { status: 0, data: { completed: true } }
   */
  completeSupportGuide() {
    const url = this.buildurl('/tutorial/complete');
    return this.http.post(url, {});
  }
}
